import { endOfDay, startOfDay } from 'date-fns';
import { atom } from 'recoil';

import { appointmentStatuses as appointmentStatusesConst } from 'lib/constants/constants';

export const currentPractice = atom({
  key: 'currentPractice',
  default: {
    id: null,
    name: '',
    email: '',
    phone: '',
    address: '',
    header_photo: null,
    timezone: 'America/New_York',
    working_hours: {},
    display_settings: null,
    appointment_types: null,
    tax_id: null,
    checkin_steps: {},
    profession_group_id: null,
    kind: null
  }
});

export const current_member = atom({
  key: 'current_member',
  default: { user_id: '', f_name: '', l_name: '', email: '', state: '', logged_in: false }
});

export const messages = atom({ key: 'practice_messages', default: { all_messages: [] } });

export const reportingFilters = atom({
  key: 'reportingFilters',
  default: {
    selectedRange: [
      { startDate: startOfDay(new Date()), endDate: endOfDay(new Date()), key: 'selection' }
    ],
    id: '',
    payer: '',
    patient: null,
    transactionFilter: []
  }
});

export const calendarFilters = atom({
  key: 'calendarFilters',
  default: {
    appointmentType: [],
    appointmentStatus: [],
    appointmentConfirmState: [],
    serviceType: [],
    patient: [],
    practitioners: [],
    resources: [],
    clinicalNoteStatus: null,
    superbillStatus: null,
    claimState: []
  }
});

export const communicationFilter = atom({
  key: 'communicationFilter',
  default: {
    order: { label: 'Newest', value: 'desc' },
    messageType: [],
    messageApply: false,
    logType: [],
    logApply: false,
    apply: false
  }
});

export const selectedPatient = atom({ key: 'selectedPatient', default: { id: null } });

// conversation_practice_id: atom({
//   key: 'practice_id',
//   default: null
// })

export const reloadCalendar = atom({ key: 'reloadCalendar', default: false });

export const currentFormBtnRefs = atom({ key: 'currentFormRefs', default: [] });

export const ownerPractices = atom({ key: 'ownerPractices', default: [] });

export const ownerSelectedLocation = atom({ key: 'ownerSelectedLocation', default: null });

export const appointmentStatuses = atom({
  key: 'appointmentStatuses',
  default: appointmentStatusesConst
});

export default {
  currentPractice,
  current_member,
  messages,
  reportingFilters,
  calendarFilters,
  communicationFilter,
  selectedPatient,
  reloadCalendar,
  currentFormBtnRefs,
  ownerPractices,
  ownerSelectedLocation,
  appointmentStatuses
};
